<template>
    <a-config-provider :locale="zhCN">
        <a-layout hasSider style="height: 100vh;overflow: hidden;">
            <a-layout-sider :width="180">
                <div class="logo">
                    <img src="../assets/logo.png" />
                </div>
                <a-menu theme="dark" mode="inline" v-model:selectedKeys="selectedKeys" :openKeys="openKeys" @openChange="onOpenChange" >

                    <a-sub-menu key="/order">
                        <template #icon>
                            <icon>
                                <template #component>
                                    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
                                        <path d="M960.829773 283.265482l-0.018419-0.147356a41.560558 41.560558 0 0 0-5.915733-16.814968l-0.01842-0.033769a41.535999 41.535999 0 0 0-3.51608-4.842285c-0.042979-0.052189-0.082888-0.101307-0.125867-0.150426a40.080857 40.080857 0 0 0-2.221597-2.415002L711.024357 16.165168a40.584324 40.584324 0 0 0-10.822486-7.835456 67.105351 67.105351 0 0 1-0.611937-0.301875 36.228109 36.228109 0 0 0-3.390213-1.445932c-0.289596-0.107447-0.584308-0.202615-0.876974-0.301875a36.853349 36.853349 0 0 0-1.744737-0.559748c-0.242524-0.070608-0.48914-0.144286-0.735757-0.211825a40.441061 40.441061 0 0 0-2.52859-0.608867 6.01704 6.01704 0 0 1-0.230244-0.039909 38.696324 38.696324 0 0 0-2.470261-0.403183c-0.159636-0.021489-0.317225-0.046049-0.47379-0.061398a39.783075 39.783075 0 0 0-4.826936-0.301875H190.659853c-67.076698 0-121.656781 55.722092-121.656781 124.180254v766.831896c0.039909 68.531839 54.506405 124.093273 121.737622 124.183323h185.897897c14.490016 0 30.763654 1.922792 30.763654-30.763654s-28.052916-30.763654-30.763654-30.763654h-215.344556c-22.38994 0-30.763654-38.623669-30.763655-61.527309v-769.086239c0-22.88829 39.072901-61.48433 61.527309-61.527309h461.451744V250.201435c0 22.826891 8.364505 30.763654 30.763654 30.763655h215.344556v615.268991c-4.808516 43.754526-37.386492 61.527308-61.527308 61.527309H684.272064c-22.396079 0-61.527308 7.927553-61.527309 30.763654 0 22.823821 28.733415 30.763654 51.125401 30.763654h165.455309c67.236334 0 121.81744-55.722092 121.81744-124.183323V288.339034a42.947138 42.947138 0 0 0-0.313132-5.073552zM662.846078 811.933093c16.422018 0.033769 31.240515-10.041704 37.534872-25.508977 6.288217-15.465227 2.802836-33.273824-8.822946-45.09608l-147.683551-150.460804a40.134069 40.134069 0 0 0-1.636266-1.596358c-0.193405-0.178055-0.393973-0.344854-0.590448-0.519839-0.286526-0.255827-0.568958-0.51063-0.861624-0.754177a50.360991 50.360991 0 0 0-1.180895-0.947581c-0.107447-0.082888-0.208754-0.171915-0.317225-0.252757-0.49835-0.378623-1.00591-0.744967-1.51347-1.098008-0.01228-0.00307-0.024559-0.01535-0.033769-0.021489-15.772218-10.893094-37.398772-9.226129-51.375088 5.01113l-147.775648 150.639883c-10.253528 10.443863-14.267958 25.665543-10.524704 39.943734 3.735068 14.280238 14.671141 25.435299 28.668946 29.268604 14.000875 3.836375 28.939099-0.233314 39.198767-10.675131l78.588893-80.225159v258.31523c0 22.826891 18.156522 41.333384 40.555671 41.333384 22.39301 0 40.549531-18.507516 40.549532-41.333384V719.726042l78.587869 80.059383c7.579629 7.769964 17.882276 12.138458 28.631084 12.147668zM315.110259 527.072277h399.925459c22.399149 0 30.763654-7.936763 30.763654-30.763654 0-22.833031-8.364505-30.760584-30.763654-30.760585H315.110259c-22.402219 0-30.763654 7.927553-30.763654 30.760585 0.001023 22.826891 8.362458 30.763654 30.763654 30.763654z m0-123.053594h399.925459c22.399149 0 30.763654-7.933693 30.763654-30.763654 0-22.833031-8.364505-30.763654-30.763654-30.763654H315.110259c-22.402219 0-30.763654 7.930623-30.763654 30.763654 0.001023 22.829961 8.362458 30.763654 30.763654 30.763654z"></path>
                                    </svg>
                                </template>
                            </icon>
                        </template>
                        <template #title>提单管理</template>
                        <router-link to="/order/order_list">
                            <a-menu-item key="/order/order_list">
                                提单列表
                            </a-menu-item>
                        </router-link>
                    </a-sub-menu>

                    <a-sub-menu key="/customer">
                        <template #icon>
                            <icon>
                                <template #component>
                                    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
                                        <path d="M683.53 494.14c47.8-45.54 77.64-109.79 77.64-180.87 0-137.78-112.09-249.88-249.88-249.88S261.42 175.48 261.42 313.27c0 71.32 30.04 135.75 78.13 181.32C177.82 562.31 63.9 722.2 63.9 908.21c0 28.36 22.99 51.35 51.35 51.35s51.35-22.99 51.35-51.35c0-186.8 149.03-339.43 334.43-345.29 3.41 0.14 6.82 0.23 10.26 0.23 3.71 0 7.39-0.1 11.06-0.26 185.77 5.45 335.23 158.25 335.23 345.32 0 28.36 22.99 51.35 51.35 51.35s51.35-22.99 51.35-51.35c-0.01-186.43-114.44-346.62-276.75-414.07zM364.11 313.27c0-81.16 66.02-147.18 147.18-147.18s147.18 66.03 147.18 147.18c0 78.07-61.1 142.1-137.99 146.87-2.79-0.05-5.59-0.11-8.4-0.11-3.26 0-6.51 0.05-9.76 0.12-76.99-4.65-138.21-68.74-138.21-146.88z"></path>
                                    </svg>
                                </template>
                            </icon>
                        </template>
                        <template #title>客户管理</template>
                        <router-link to="/customer/customer_list">
                            <a-menu-item key="/customer/customer_list">
                                客户列表
                            </a-menu-item>
                        </router-link>
                        <router-link to="/customer/activation_code_list">
                            <a-menu-item key="/customer/activation_code_list">
                                激活码列表
                            </a-menu-item>
                        </router-link>
                    </a-sub-menu>

                    <a-sub-menu key="/finance">
                        <template #icon>
                            <icon>
                                <template #component>
                                    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
                                       <path d="M824.832 102.4H229.888A127.488 127.488 0 0 0 102.4 229.888v594.944a127.488 127.488 0 0 0 127.488 127.488h594.944a127.488 127.488 0 0 0 127.488-127.488V229.888A127.488 127.488 0 0 0 824.832 102.4z m42.496 722.432a42.496 42.496 0 0 1-42.496 42.496H229.888a42.496 42.496 0 0 1-42.496-42.496V229.888a42.496 42.496 0 0 1 42.496-42.496h594.944a42.496 42.496 0 0 1 42.496 42.496zM644.096 286.72L527.36 420.352 409.6 286.72a43.008 43.008 0 0 0-60.416-4.096 42.496 42.496 0 0 0-2.56 60.416l123.904 141.824H399.872a42.496 42.496 0 0 0 0 84.992h84.992V614.4H399.872a42.496 42.496 0 0 0 0 84.992h84.992v42.496a42.496 42.496 0 0 0 84.992 0v-42.496h84.992a42.496 42.496 0 0 0 0-84.992h-84.992v-42.496h84.992a42.496 42.496 0 0 0 0-84.992H583.68l124.416-143.872a43.008 43.008 0 0 0-4.096-59.904 42.496 42.496 0 0 0-59.904 3.584z"></path>
                                    </svg>
                                </template>
                            </icon>
                        </template>
                        <template #title>财务管理</template>
                        <router-link to="/finance/balance_log">
                            <a-menu-item key="/finance/balance_log">
                                预存款明细
                            </a-menu-item>
                        </router-link>
                    </a-sub-menu>
                </a-menu>
            </a-layout-sider>
            <a-layout>
                <a-layout-header
                    style="display: flex;justify-content: space-between;background: #fff; padding: 0 16px;height: 50px;">
                    <div></div>
                     <!-- 右侧功能区 -->
                    <div class="admin-header-tool">
                        <div class="admin-header-tool-item">
                            <a-dropdown placement="bottomRight">
                                <div class="admin-header-avatar">
                                    <a-avatar :size="26" :src="agentInfo.avatar ? $common.cdnurl(agentInfo.avatar,true) : ''" style="color: #f56a00; background-color: #fde3cf">
                                        {{agentInfo['nickname'].substring(0,1)}}
                                    </a-avatar>
                                    <span class="admin-header-nickname">{{agentInfo['nickname']}}</span>
                                    <DownOutlined />
                                </div>
                                <template #overlay>
                                    <a-menu style="width:120px;">
                                        <a-menu-item @click="clickAccount" style="text-align: center;height: 40px;padding: 0px 20px;">
                                            <setting-outlined />
                                            <a href="javascript:;" style="margin-left: 10px;">账号设置</a>
                                        </a-menu-item>
                                        <a-menu-divider />
                                        <a-menu-item @click="clickLogout" style="text-align: center;height: 40px;padding: 0px 20px;">
                                            <poweroff-outlined />
                                            <a href="javascript:;" style="margin-left: 10px;">退出登录</a>
                                        </a-menu-item>
                                    </a-menu>
                                </template>
                            </a-dropdown>
                        </div>
                    </div>
                </a-layout-header>
                <a-layout-content style="overflow-x: hidden;overflow-y: auto;">
                    <div style="margin: 16px;">
                        <router-view />
                    </div>
                </a-layout-content>
            </a-layout>
        </a-layout>  
    </a-config-provider>
</template>
<script>
    import { defineComponent,computed,reactive,toRefs,watch} from 'vue';
    import { Modal } from 'ant-design-vue';
    import zhCN from 'ant-design-vue/es/locale/zh_CN';

    import dayjs from 'dayjs';
    import 'dayjs/locale/zh-cn';
    dayjs.locale('en');

    import Icon,{SettingOutlined,PoweroffOutlined} from '@ant-design/icons-vue';

    import useAgent from '@/stores/agent';

    import { useRouter } from 'vue-router';

    export default defineComponent({
        name: 'BasicLayout',
        components: {
            Icon,
            SettingOutlined,
            PoweroffOutlined
        },
        setup() {
            //代理商信息
            const agentStore = useAgent();
            const agentInfo = computed(() => agentStore.agentInfo);

            const router = useRouter();

            const state = reactive({
                rootSubmenuKeys: ['/order','/customer','/finance'],
                openKeys: ['/order'],
                selectedKeys: [],
            });

            const updateMenu = ()=> {
                const routes = router.currentRoute.value.path;
                if(router === '/order/order_list'){
                    state.openKeys = ['/order'];
                }else if(routes == '/customer/customer_list' || routes == '/customer/activation_code_list'){
                    state.openKeys = ['/customer'];
                }else if(routes == '/finance/balance_log'){
                    state.openKeys = ['/finance'];
                }
                state.selectedKeys = [routes];
            }

            watch(() => updateMenu());

            const onOpenChange = openKeys => {
                const latestOpenKey = openKeys.find(key => state.openKeys.indexOf(key) === -1);
                if (state.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
                    state.openKeys = openKeys;
                } else {
                    state.openKeys = latestOpenKey ? [latestOpenKey] : [];
                }
            }

            //账号设置
            const clickAccount = () => {
                router.push('/set/account');
            }

            //退出登录
            const clickLogout = () => {
                Modal.confirm({
                    title: '提示',
                    content: '确定要退出登录吗？',
                    cancelText: '取消',
                    okText: '确定',
                    centered: true,
                    onOk: () => {
                        agentStore.Logout().then((res) => {
                            router.push('/agent/login');
                        });
                    }
                });
            }

            return {
                zhCN,

                agentInfo,

                ...toRefs(state),
                onOpenChange,

                clickAccount,
                clickLogout
            }
        }
    })
</script>
<style lang="less" scoped>
.logo {
    width: 40px;
    height: 40px;
    margin: 15px auto;
}

.logo img {
    width: 100%;
}

.admin-header-tool-item {
    height: 50px;
}

.admin-header-avatar {
    height: 50px;
    display: flex;
    align-items: center;
}

.admin-header-nickname {
    margin-left: 8px;
    margin-right: 5px;
    font-size: 14px;
}
</style>
<style>
.menu .ant-menu-item-group-title {
    padding-left: 24px;
}

.menu .ant-menu-item {
    padding-left: 24px !important;
    font-size: 13px;
}
</style>